import {
  allowedBackButtonRoutes,
  showBackButtonForContent,
} from '@core/constants/backButtonNavigation';
import { push, replace } from 'react-router-redux';
import { currentClassRoomId } from '../../../core/selectors/classroom';

const selectSection =
  (sectionId, educatorOnly = false, { event } = {}) =>
  (dispatch, getState) => {
    const state = getState();
    const classRoomId = currentClassRoomId(state);
    // Duplicated selectSection function for the new route path (within the Journey tab).
    // This needs to be duplicated while the new Information Architecture changes are only
    // done for Desktop.

    // Check if any from parameters are available in the url
    const { queryParams } = showBackButtonForContent();
    const query = { ...queryParams };

    const tab = educatorOnly ? 'educatorArea' : 'materials';

    // QUICK FIX: Handle navigation after deleting a section.
    // 1. This fixes 2 scenarios: when user creates a new page and deletes it
    // 2. when user deletes an existing page
    if (event === 'delete') {
      if (query?.from) {
        query.from = query?.from.split(',')[0];
      }
      dispatch(
        push({
          pathname: `/dashboard/${classRoomId}/journey/${tab}/${sectionId}${
            query?.from ? `?from=${query.from}` : ''
          }`,
        })
      );
      return;
    }

    // QUICK FIX: Handle navigation after saving a section
    // 1. If the event is save then replace the url with newly added query params
    if (event === 'save') {
      if (query?.from) {
        query.from = query?.from.split(',')[0];
      }
      dispatch(
        replace({
          pathname: `/dashboard/${classRoomId}/journey/${tab}/${sectionId}${
            query?.from ? `?from=${query.from}` : ''
          }`,
        })
      );
    }

    // Scenario: when user clicks new page we are appending an extra value for
    // 'from' to handle back button navigation. Logo leave uses location state
    // instead, so this append can stay for back-button chain behavior.
    const isAddNewPage =
      typeof sectionId === 'string' &&
      (sectionId.startsWith('local') || sectionId.includes('local'));
    // Append the path along with the other parameter only if it is add page
    if (
      query?.from &&
      allowedBackButtonRoutes?.includes(query?.from) &&
      isAddNewPage
    ) {
      query.from = `${query.from},${tab}`;
    }

    const url =
      sectionId !== null
        ? `/dashboard/${classRoomId}/journey/${tab}/${sectionId}`
        : `/dashboard/${classRoomId}/journey/${tab}`;
    dispatch(
      push({
        pathname: url,
        ...(Object.keys(query).length > 0 && { query }), // only include query if from exists
      })
    );
  };

export default selectSection;
